<div class="white-box main-black mt-4 p-4 border-radius">
	<div class="row mb-4">
		<div class="col">
			<h4>
				{{'utilization.daily_truck_usage_report' | translate}}
			</h4>
		</div>
	</div>

	<!-- date filter -->
	<div class="row col-xl-7 mb-4">
		<div class="col-xl-6 col-md-6">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.start_date' | translate}}</span>
				</div>
				<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp1" (ngModelChange)="changeDate('fromDate', $event)" [ngModel]="fromDate" bsDatepicker #d1="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [maxDate]="toDate" [minDate]="minDate">
				<div class="input-group-append pointer" (click)="d1.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>

		<div class="col-xl-6 col-md-6">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.end_date' | translate}}</span>
				</div>
				<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp2" (ngModelChange)="changeDate('toDate', $event)" [ngModel]="toDate" bsDatepicker #d2="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [minDate]="fromDate" [maxDate]="maxDate">
				<div class="input-group-append pointer" (click)="d2.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>
	</div>

	<!-- table -->
	<div class="col-12">
		<sct-custom-table
			#sctCustomTable
			[columnsConfig]="columnConfig"
			[data]="tableData"
			[config]="tableConfig"
		></sct-custom-table>
	</div>
</div>
